import React from 'react';
import Galleries from './Galleries';
import Header from './Header';

import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Bar />
      <S.Content>
        <S.Text>
          <p>
            Então, é junho. Está frio, você abre o seu armário e o seu coração
            afunda. As camadas se tornaram obrigatórias, o comprimento curto só
            será possível se acompanhado de uma boa meia-calça e certos frufrus
            são dispensados, já que o conforto passou a ser clamado. Para
            alguns, trocar as peças vibrantes e de veraneio pelas adequadas para
            o inverno pode ser um sacrifício ou, no mínimo, o início de uma
            temporada repetitiva. É que, nas temperaturas baixas, o modo
            automático parece ser ativado e aquelas mesmas combinações de sempre
            entram em cena como uma espécie de uniforme.
          </p>
          <p>
            Para Mercado Livre, no entanto, não precisa ser assim. Buscando
            desmistificar tudo aquilo que um dia você já pensou sobre o visual
            de inverno, a plataforma te convida a repensar. Seja investindo nas
            peças de roupa certas, seja entendendo como aplicar seu gosto
            pessoal a elas, elaborar um visual aquecido, confortável e ainda
            estiloso se torna mais fácil quando a moda é a sua aliada.
          </p>
          <p>
            À frente, uma curadoria especial de produtos disponíveis em Mercado
            Livre, que reúne de essenciais do guarda-roupa às tendências da
            estação. Entre as peças, as jaquetas são umas das favoritas. De
            couro ou pelúcia, a sobreposição, além de proteger do frio, pode ser
            a protagonista da produção. Um outro destaque vai para a saia de
            tule que, no inverno, ganha vida nova ao ser contrastada com
            símbolos pesados. Já nos acessórios as botas coloridas e as bolsas
            texturizadas também fazem lembrar que se vestir para as baixas
            temperaturas não precisa ser chato, muito menos óbvio.
          </p>
        </S.Text>
      </S.Content>
      <S.Bar />
      <Galleries />
      <S.Bar />
    </S.Container>
  );
};

export default Main;
